import React, {useState} from "react";
import './PopUpYesNo.css'
import SniperCamButton from "./SniperCamButton";

export default function PopUpAddCustomer({onAdd, onClose, error}) {
    const [customerName, setCustomerName] = useState("");

    const handleAdd = () => {
        if (onAdd) {
            onAdd(customerName);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleAdd();
        }
        if (e.key === "Escape") {
            onClose();
        }
    };

    return (
        <div className={'popUpYesNoOverlay'}>
            <div className={'popUpBoxYesNo'}>
                <h1 className={'popUpYesNoText'} style={{marginTop: '20vh', marginBottom: '20px'}}>Add New Customer</h1>
                <div style={{textAlign: 'center', marginBottom: '30px'}}>
                    <input
                        placeholder="Enter customer name"
                        type="text"
                        value={customerName}
                        onChange={(e) => setCustomerName(e.target.value)}
                        onKeyDown={handleKeyDown}
                        autoFocus
                        style={{
                            padding: '10px',
                            fontSize: '18px',
                            width: '60%',
                            borderRadius: '5px',
                            border: '1px solid #ccc'
                        }}
                    />
                </div>
                {error && <h3 style={{color: 'red', textAlign: 'center'}}>{error}</h3>}
                <SniperCamButton onClick={handleAdd} text="Add Customer" button_type={'GreenButton'} large={true}/>
                <SniperCamButton onClick={onClose} text={'Cancel'} button_type={'RedButton'} large={true}/>
            </div>
        </div>
    );
}
